import { Links } from 'ui/components';

export const LinksFeature: React.FC<Umbraco.Links> = ({ content }) => <Links {...content?.properties} />;
